import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import App from './App';

const theme = extendTheme({
  config: { initialColorMode: 'light', useSystemColorMode: false },
});

// Always use light mode — ignore any cached dark mode value in localStorage.
const forceLightMode = {
  type: 'localStorage',
  ssr: false,
  get: () => 'light',
  set: () => {},
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme} colorModeManager={forceLightMode}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);
